// badge.js
import React from "react";
import { View } from "react-native";
import { Text, styled } from "@ui-kitten/components";
import styles from "./badge.style";

@styled("Badge")
class Badge extends React.Component {
  renderBadgeComponent = () => {
    const { eva, style, count, children, ...restProps } = this.props;
    switch (typeof count) {
      case "number":
      case "string":
        return (
          <View style={[eva.style, styles.badge, style]} {...restProps}>
            <Text
              style={{
                color: eva.style.textColor,
                fontSize: eva.style.textFontSize,
                fontWeight: eva.style.textFontWeight,
              }}
            >
              {this.props.count}
            </Text>
          </View>
        );
      case "function":
        return count();
    }
  };
  render() {
    const { children } = this.props;
    return (
      <View style={styles.badgeContainer}>
        <View style={children ? styles.badgeContainerAbsolute : null}>
          {this.renderBadgeComponent()}
        </View>
        {children}
      </View>
    );
  }
}
